import React from "react";

/**
 * Klareet wordmark. White variant reads on navy bg.
 * variant: "wordmark" | "icon"
 */
export function Logo({ variant = "wordmark", className = "", alt = "Klareet" }) {
    const src =
        variant === "icon" ? "/logos/klareet-white-mono.png" : "/logos/klareet-white.png";
    return <img src={src} alt={alt} className={className} draggable={false} />;
}
